import React, {
    useContext,
    useEffect,
    useState
} from 'react';
import Head from 'next/head';

import { RequestNextApi } from '../../api/Request';
import { ProgressContext } from '../../components/Context/progressContext';
import MarketingNavigation from '../../navigation/marketing';
import { ShowNotification } from '../../utils/notification/snackbarUtils';
import { showArticleBlock } from '../../utils/static-pages/function';
import { PAGES_SLUG } from '../../utils/static-pages/model';

export default function Community() {
    const [articleBlocks, setArticleBlocks] = useState();
    const { state: progressContext, update: updateProgress } = useContext(ProgressContext);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const res = await RequestNextApi.post('/pages',
                    {
                        slug: PAGES_SLUG.MARKETING_COMMUNITY,
                    }
                );
                if (res.data.success) {
                    setArticleBlocks(res.data.page.articleBlocks);
                } else {
                    ShowNotification.error('Fetch page failed');
                }
            } catch (error) {
                ShowNotification.error('Fetch page failed');
            }
        };

        const initPage = async () => {
            updateProgress({ isLoading: true });
            await fetchPage();
            updateProgress({ isLoading: false });
        };

        initPage();
    }, []);

    return (
        <>
            <Head>
                <title>Christian Financial Professionals Association | Join & Grow</title>
                <meta name="description" content="Join Kingdom Advisors to connect with like-minded professionals and discover resources that help you align clients’ values with their financial decisions." />
            </Head>
            <MarketingNavigation>
                <div className='marketing-home--community'>
                    {articleBlocks?.map((item, index) => (
                        showArticleBlock(item, index)
                    ))}
                </div>
            </MarketingNavigation>
        </>
    )
}

Community.getLayout = page => <>{page}</>;
Community.isPublic = true;
